// src/components/shared/NotFoundPage.js
// Branded 404 page with animated wrench illustration

import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "@dr.pogodin/react-helmet";

const NotFoundPage = () => {
  return (
    <>
    {/* No canonical: a 404 must not claim to be (or point at) another page. */}
    <Helmet>
      <title>Page Not Found | CompareMechanic</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "2rem 1.5rem",
        textAlign: "center",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      {/* Animated wrench + car illustration */}
      <div style={{ position: "relative", marginBottom: "1.5rem" }}>
        {/* Car silhouette */}
        <svg
          width="120"
          height="60"
          viewBox="0 0 120 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          {/* Car body */}
          <path
            d="M15 40 L25 40 L30 25 L50 20 L75 20 L90 25 L95 40 L105 40 L105 48 L15 48 Z"
            fill="#105d8e"
            opacity="0.15"
          />
          {/* Car roof */}
          <path
            d="M35 25 L45 12 L75 12 L85 25"
            stroke="#105d8e"
            strokeWidth="2"
            fill="none"
            opacity="0.3"
          />
          {/* Wheels */}
          <circle cx="35" cy="48" r="8" fill="#105d8e" opacity="0.2" />
          <circle cx="85" cy="48" r="8" fill="#105d8e" opacity="0.2" />
          <circle cx="35" cy="48" r="4" fill="#fff" />
          <circle cx="85" cy="48" r="4" fill="#fff" />
        </svg>

        {/* Animated wrench */}
        <svg
          className="wrench-swing"
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          style={{
            position: "absolute",
            top: "-10px",
            right: "-5px",
          }}
        >
          <path
            d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
            fill="#f37f09"
            stroke="#f37f09"
            strokeWidth="0.5"
          />
        </svg>
      </div>

      {/* 404 heading */}
      <h1
        style={{
          fontSize: "clamp(4rem, 10vw, 7rem)",
          fontWeight: 800,
          color: "#105d8e",
          margin: "0 0 0.25rem",
          lineHeight: 1,
          letterSpacing: "-2px",
        }}
      >
        404
      </h1>

      {/* Fun subheading */}
      <h2
        style={{
          fontSize: "clamp(1.1rem, 3vw, 1.4rem)",
          fontWeight: 600,
          color: "#333",
          margin: "0 0 0.5rem",
        }}
      >
        Looks like this page took a wrong turn!
      </h2>

      <p
        style={{
          fontSize: "0.95rem",
          color: "#666",
          maxWidth: "400px",
          margin: "0 0 2rem",
          lineHeight: 1.5,
        }}
      >
        The page you're looking for doesn't exist or may have been moved. Let's
        get you back on the road.
      </p>

      {/* Action buttons */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <Link
          to="/"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "12px 28px",
            minHeight: "44px",
            background: "#105d8e",
            color: "#fff",
            border: "none",
            borderRadius: "16px",
            fontSize: "0.95rem",
            fontWeight: 600,
            fontFamily: "'Poppins', sans-serif",
            textDecoration: "none",
            cursor: "pointer",
            transition: "background 0.2s",
          }}
        >
          Go Home
        </Link>
        <Link
          to="/search-results"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "12px 28px",
            minHeight: "44px",
            background: "transparent",
            color: "#f37f09",
            border: "2px solid #f37f09",
            borderRadius: "16px",
            fontSize: "0.95rem",
            fontWeight: 600,
            fontFamily: "'Poppins', sans-serif",
            textDecoration: "none",
            cursor: "pointer",
            transition: "background 0.2s, color 0.2s",
          }}
        >
          Search Garages
        </Link>
      </div>

      {/* Keyframes for wrench swing animation */}
      <style>
        {`
          .wrench-swing {
            animation: wrenchSwing 2.5s ease-in-out infinite;
            transform-origin: 50% 100%;
          }
          @keyframes wrenchSwing {
            0%, 100% { transform: rotate(0deg); }
            25% { transform: rotate(20deg); }
            50% { transform: rotate(-15deg); }
            75% { transform: rotate(10deg); }
          }
        `}
      </style>
    </div>
    </>
  );
};

export default NotFoundPage;
